import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=714b29e2&scoped=true&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=714b29e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714b29e2",
  null
  
)

export default component.exports